"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _teaComponent = require("@tencent/tea-component");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Link = _interopRequireDefault(require("../Link"));
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var GradientDescDialog = function GradientDescDialog(props) {
  var _info$detailsLink, _info$detailsLink4, _tableData$header, _tableData$records;
  var className = props.className,
    style = props.style,
    visible = props.visible,
    onClose = props.onClose,
    info = props.info,
    title = props.title,
    tableTitle = props.tableTitle,
    tableDesc = props.tableDesc,
    tableData = props.tableData,
    btn = props.btn;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('gradient-desc-dialog');
  var classes = (0, _classnames.default)(prefixCls, className);
  var closeHandler = function closeHandler() {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  var renderStyle = function renderStyle(index) {
    var _tableData$header$ind, _tableData$header$ind2;
    return {
      width: (tableData === null || tableData === void 0 ? void 0 : tableData.header) && (tableData === null || tableData === void 0 ? void 0 : (_tableData$header$ind = tableData.header[index]) === null || _tableData$header$ind === void 0 ? void 0 : _tableData$header$ind.width),
      flex: !(tableData !== null && tableData !== void 0 && tableData.header && tableData !== null && tableData !== void 0 && (_tableData$header$ind2 = tableData.header[index]) !== null && _tableData$header$ind2 !== void 0 && _tableData$header$ind2.width) ? 1 : 'none'
    };
  };
  var renderCol = function renderCol(value) {
    var data = value.split('-');
    return data.map(function (value, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "item-text",
        key: index
      }, value), index !== data.length - 1 && /*#__PURE__*/_react.default.createElement("div", {
        className: "item-line"
      }, "-"));
    });
  };
  return /*#__PURE__*/_react.default.createElement(_teaComponent.Modal, {
    visible: visible
    // caption="版本功能对比"
    ,
    onClose: closeHandler,
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_teaComponent.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info")
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-hd")
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-bd")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-main")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__info-img"),
    style: {
      backgroundImage: "url(".concat(info === null || info === void 0 ? void 0 : info.img, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-params")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-name")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-text")
  }, info === null || info === void 0 ? void 0 : info.name), (info === null || info === void 0 ? void 0 : info.vip) && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-vip")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-desc")
  }, info === null || info === void 0 ? void 0 : info.deadline))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__info-side")
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    type: "arrow",
    className: "".concat(prefixCls, "__info-link"),
    href: info === null || info === void 0 ? void 0 : (_info$detailsLink = info.detailsLink) === null || _info$detailsLink === void 0 ? void 0 : _info$detailsLink.href,
    onClick: function onClick() {
      var _info$detailsLink2;
      if (typeof (info === null || info === void 0 ? void 0 : (_info$detailsLink2 = info.detailsLink) === null || _info$detailsLink2 === void 0 ? void 0 : _info$detailsLink2.onClick) === 'function') {
        var _info$detailsLink3;
        info === null || info === void 0 ? void 0 : (_info$detailsLink3 = info.detailsLink) === null || _info$detailsLink3 === void 0 ? void 0 : _info$detailsLink3.onClick(info === null || info === void 0 ? void 0 : info.detailsLink);
      }
    }
  }, info === null || info === void 0 ? void 0 : (_info$detailsLink4 = info.detailsLink) === null || _info$detailsLink4 === void 0 ? void 0 : _info$detailsLink4.text)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__main")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__main-hd")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__main-title")
  }, tableTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__main-close")
  }), /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    icon: 'close',
    className: "".concat(prefixCls, "__main-close"),
    onClick: function onClick() {
      closeHandler();
    }
  }, "\u5173\u95ED")), tableDesc && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__main-desc")
  }, tableDesc), tableData && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__table")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__table-tr th")
  }, tableData === null || tableData === void 0 ? void 0 : (_tableData$header = tableData.header) === null || _tableData$header === void 0 ? void 0 : _tableData$header.map(function (header, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-td"),
      key: index,
      style: {
        width: header.width,
        flex: !header.width ? 1 : 'none'
      }
    }, (header === null || header === void 0 ? void 0 : header.icon) && /*#__PURE__*/_react.default.createElement("i", {
      className: "icon-".concat(header === null || header === void 0 ? void 0 : header.icon)
    }), header === null || header === void 0 ? void 0 : header.value);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__table-body")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__table-body-section")
  }, (_tableData$records = tableData.records) === null || _tableData$records === void 0 ? void 0 : _tableData$records.map(function (record, index) {
    var _record$grad;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-tr"),
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-td name-col"),
      style: renderStyle(0)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-section")
    }, record.name)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-td grad-col"),
      style: renderStyle(1)
    }, record === null || record === void 0 ? void 0 : (_record$grad = record.grad) === null || _record$grad === void 0 ? void 0 : _record$grad.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__table-section"),
        key: index
      }, item.value);
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-td"),
      style: renderStyle(2)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-section")
    }, record.webinar)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-td"),
      style: renderStyle(3)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__table-section")
    }, record.meeting)));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__footer")
  }, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    type: !(btn !== null && btn !== void 0 && btn.type) ? 'primary' : btn === null || btn === void 0 ? void 0 : btn.type,
    className: "".concat(prefixCls, "__btn"),
    onClick: function onClick(event) {
      (btn === null || btn === void 0 ? void 0 : btn.onClick) && btn.onClick();
    }
  }, btn === null || btn === void 0 ? void 0 : btn.text)))));
};
var _default = GradientDescDialog;
exports.default = _default;